import * as math from 'mathjs';

let arithmetic = {
    //加法
    add(a,b){
        return math.add(math.bignumber(a), math.bignumber(b));
    },

    //减法
    subtract(a,b){
        return math.subtract(math.bignumber(a), math.bignumber(b));
    },

    // 乘法
    multiply(a,b){
        return math.subtract(math.bignumber(a), math.bignumber(b));
    },

    // 除法
    divide(a,b){
        return math.subtract(math.bignumber(a), math.bignumber(b));
    },

    add5(a,b,c,d,e){
        if(!c && c.length==0) c=0;
        if(!d && d.length==0) d=0;
        if(!e && e.length==0) e=0;      
        let sum = new Number(a)+new Number(b)+new Number(c)+new Number(d)+new Number(e) 
        //console.log('a+b+c+d+e',sum);
        return sum;
    }

}

export default arithmetic;